import { render, staticRenderFns } from "./dialogMember.vue?vue&type=template&id=28eda70c&scoped=true"
import script from "./dialogMember.vue?vue&type=script&lang=js"
export * from "./dialogMember.vue?vue&type=script&lang=js"
import style0 from "./dialogMember.vue?vue&type=style&index=0&id=28eda70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eda70c",
  null
  
)

export default component.exports